export default __webpack_public_path__ + "static/backgroundImage-b09c650c9d4213b5c29b76cc8422df3a.png";